import api from "apis/customer";
import {
  REQUEST_CUSTOMER_MAJORCOMPANIES,
  RECEIVE_CUSTOMER_MAJORCOMPANIES,
  ERROR_CUSTOMER_MAJORCOMPANIES,
  REQUEST_CUSTOMER_SEARCH_TEXT,
  RECEIVE_CUSTOMER_SEARCH_TEXT,
  ERROR_CUSTOMER_SEARCH_TEXT,
  REQUEST_CUSTOMER_SEARCH_OPTIONS,
  RECEIVE_CUSTOMER_SEARCH_OPTIONS,
  ERROR_CUSTOMER_SEARCH_OPTIONS,
  REQUEST_CUSTOMER_DETAILS,
  RECEIVE_CUSTOMER_DETAILS,
  ERROR_CUSTOMER_DETAILS,
  REQUEST_CUSTOMER_SCORECARD,
  RECEIVE_CUSTOMER_SCORECARD,
  ERROR_CUSTOMER_SCORECARD,
  REQUEST_CUSTOMER_FEATURES,
  RECEIVE_CUSTOMER_FEATURES,
  ERROR_CUSTOMER_FEATURES,
  REQUEST_INSURANCECUSTOMER_GET_CASENFO,
  RESPONSE_INSURANCECUSTOMER_GET_CASENFO,
  ERROR_INSURANCECUSTOMER_GET_CASENFO,
  SET_SELECTED_SURVEY_TYPE,
  SET_SELECTED_CUSTOMER,
} from "typeConstants";
import { HTTP_GET, HTTP_POST, WebApiReduxRequest } from "tools/webservice";
import { CALL_API } from "redux-api-middleware";
import responseHandler from "responseHandler";

const getMajorCompanies = () => WebApiReduxRequest(
  REQUEST_CUSTOMER_MAJORCOMPANIES,
  RECEIVE_CUSTOMER_MAJORCOMPANIES,
  ERROR_CUSTOMER_MAJORCOMPANIES,
  HTTP_GET,
  api.majorCompanies()
);

const searchCustomersText = (searchTerm) => WebApiReduxRequest(
  REQUEST_CUSTOMER_SEARCH_TEXT,
  RECEIVE_CUSTOMER_SEARCH_TEXT,
  ERROR_CUSTOMER_SEARCH_TEXT,
  HTTP_GET,
  api.searchWithText(searchTerm)
);

const searchCustomersOptions = (options) => WebApiReduxRequest(
  REQUEST_CUSTOMER_SEARCH_OPTIONS,
  RECEIVE_CUSTOMER_SEARCH_OPTIONS,
  ERROR_CUSTOMER_SEARCH_OPTIONS,
  HTTP_POST,
  api.searchWithOptions(),
  options
);

const getCustomerDetails = (customerNumber) => WebApiReduxRequest(
  REQUEST_CUSTOMER_DETAILS,
  RECEIVE_CUSTOMER_DETAILS,
  ERROR_CUSTOMER_DETAILS,
  HTTP_GET,
  api.getCustomerDetails(customerNumber)
);

const getCustomerScorecardData = () => WebApiReduxRequest(
  REQUEST_CUSTOMER_SCORECARD,
  RECEIVE_CUSTOMER_SCORECARD,
  ERROR_CUSTOMER_SCORECARD,
  HTTP_GET,
  api.getCustomerScorecardData()
);

const getEnabledFeatures = (accountNumber, callback = null) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint: api.getEnabledFeatures(accountNumber),
        method: HTTP_GET,
        types: [
          REQUEST_CUSTOMER_FEATURES,
          {
            type: RECEIVE_CUSTOMER_FEATURES,
            payload: (action, state, res) =>
              res.json().then(data => {
                callback && callback(data);
                return data;
              })
          },
          {
            type: ERROR_CUSTOMER_FEATURES,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getCaseInfo = (controlIdNumber) => WebApiReduxRequest(
  REQUEST_INSURANCECUSTOMER_GET_CASENFO,
  RESPONSE_INSURANCECUSTOMER_GET_CASENFO,
  ERROR_INSURANCECUSTOMER_GET_CASENFO,
  HTTP_GET,
  api.getCaseInfo(controlIdNumber)
);

const setSelectedSurveyType = payload => dispatch => dispatch({
  type: SET_SELECTED_SURVEY_TYPE,
  payload,
});

const setSelectedCustomerNumber = payload => dispatch => dispatch({
  type: SET_SELECTED_CUSTOMER,
  payload,
});

export {
  getMajorCompanies,
  searchCustomersText,
  searchCustomersOptions,
  getCustomerDetails,
  getCustomerScorecardData,
  getEnabledFeatures,
  getCaseInfo,
  setSelectedSurveyType,
  setSelectedCustomerNumber,
};
